module.exports = __webpack_public_path__ + "static/media/icon_135.af635410.svg";